import { useEffect, useState } from 'react';

export const useCtrlKey = (key: string): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        function handleKeyDown(e: KeyboardEvent) {
            if ((e.metaKey || e.ctrlKey) && e.key === key) {
                e.preventDefault();
                e.stopPropagation();
                setOpen((currentValue) => !currentValue);
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return [open, setOpen];
};
